import { Box, styled } from "@mui/material";

export const ActionListItemStyles = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "6px 10px",
    ".MuiBox-root": {
        display: "flex",
        alignItems: "center",
        ".MuiButtonBase-root": {
            width: "20px",
            background: "none",
            border: "none",
            padding: "0",
            marginRight: "10px",
            svg: {
                width: "auto",
                height: "1rem",
            },
        },
    },
}));

export const DialogListBox = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(2),
    maxHeight: "300px",
    overflowY: "auto",
    borderTop: `1px solid ${theme.palette.border.main}`,
}));

export const StyledDialogListBox = styled(DialogListBox)(({ theme }) => ({
    maxHeight: "500px",
    overflowY: "auto",
    marginTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.border.main}`,
}));
